import React, { useContext } from 'react';
import { useTranslate } from '@bynder/localization';

import { IconAddCircle, IconCaretDown, IconFolder } from '@bynder/icons';
import { AbilityContext } from '../../abilities/Can';
import { isModule, isView } from '../../helpers/windowLocation';
import { iconSizeLarge, iconSizeMedium } from '../../helpers/iconSizes';

interface Props {
	isDropdownOpen: boolean;
	toggleDropdown: () => void;
}

export function CTADropdown(props: Props) {
	const ability = useContext(AbilityContext);

	const items = [
		{
			isShown: isModule('brands') && ability.can('select', 'create_new_brand'),
			component: <CreateNewBrandItem key="create-new-brand-item" />,
		},
		{
			isShown:
				(isModule('news') || (isModule('account') && isView('dashboard'))) &&
				ability.can('select', 'add_news'),
			component: <AddNewsItem key="add-news-item" />,
		},
	];

	const shownItems = items.filter((item) => item.isShown);

	if (shownItems.length === 0) {
		return null;
	}

	return (
		<li className={props.isDropdownOpen ? 'show' : ''}>
			<a href="#" onClick={props.toggleDropdown} className="cta-main cta-dropdown-trigger">
				<IconCaretDown size={iconSizeLarge} />
			</a>

			<ul className="cta-dropdown">{shownItems.map((item) => item.component)}</ul>
		</li>
	);
}

function CreateNewBrandItem() {
	const { translate } = useTranslate();

	return (
		<li>
			<a href="/brands/add/">
				<IconFolder size={iconSizeMedium} /> {translate('brands.makeNew')}
			</a>
		</li>
	);
}

function AddNewsItem() {
	const { translate } = useTranslate();

	return (
		<li>
			<a href="/news/edit/" className="add-news">
				<IconAddCircle size={iconSizeMedium} />
				{translate('news.addNews')}
			</a>
		</li>
	);
}
